<template>
    <div>
        <div class="flex items-center gap-x-2">
            <label for="combobox" class="mb-0 block text-sm/6 font-medium text-gray-900">Selected States</label>
            <button
                type="button"
                @click="isOpen = ! isOpen"
                class="underline text-blue-600 text-xs font-semibold"
            >
                Manage
            </button>
            <button
                type="button"
                @click="resetCRESiteIQMap"
                class="underline text-blue-600 text-xs font-semibold"
            >
                Clear
            </button>
        </div>
        <div class="relative">
            <div v-show="isOpen" class="flex flex-col absolute z-10 mt-1 ">
                <ul class="max-h-96 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm" id="options" role="listbox">
                    <li class="py-2">
                        <div class="relative px-4 cursor-default select-none text-gray-900">
                            <span class="block truncate">
                                <input type="search" v-model="searchCriteria" class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50" placeholder="Search..." />
                            </span>

                            <span class="absolute inset-y-0 left-0 flex items-center pl-8 text-indigo-600">
                                <inline-svg name="search" classes="w-4 h-4 text-gray-500 dark:text-gray-400"></inline-svg>
                            </span>
                        </div>
                    </li>
                    <li
                        @click="toggleState(state.name)"
                        v-for="(state, stateIndex) in namedStates" :key="stateIndex"
                        class="relative cursor-default select-none py-2 pl-6 pr-4 text-gray-900 hover:bg-gray-50 hover:cursor-pointer">
                        <span class="block truncate pl-2" :class="{ 'font-semibold': creSiteIQ.selectedStates.includes(state.name)}">{{  state.name }}</span>

                        <span v-if="creSiteIQ.selectedStates.includes(state.name)" class="absolute inset-y-0 left-0 flex items-center pl-1.5 text-indigo-600">
                          <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                            <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
                          </svg>
                        </span>
                    </li>
                </ul>
                <button
                    @click="isOpen = false"
                    class="p-3 bg-gray-100 w-full font-semibold text-sm border border-gray-200 rounded-b-lg hover:text-gray-700"
                    type="button">
                    Close
                </button>
            </div>
        </div>

        <div v-if="creSiteIQ.selectedStates.length" class="relative mt-2 flex items-center flex-wrap gap-x-2 gap-y-2">
            <div v-for="state in creSiteIQ.selectedStates" :key="state" class="w-full px-3 py-2 flex items-center justify-between max-w-fit gap-x-2 gap-y-2 text-sm font-medium bg-teal-600 text-white rounded-lg">
                <span class="font-semibold">{{ state }}</span>
                <button
                    type="button"
                    @click="toggleState(state)">
                        <svg class="stroke-white w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                </button>
            </div>
        </div>

        <div v-else class="mt-1 text-sm text-gray-600 font-medium">None selected</div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import InlineSvg from "../InlineSvg";

    export default {
        components: {InlineSvg},

        data() {
            return {
                isOpen: false,
                searchCriteria: null
            }
        },

        computed: {
            namedStates() {
                return (this.availableStates || []).filter(state => state.name != null);
            },

            ...mapState(['reatlas']),
            ...mapState(['creSiteIQ']),

            availableStates() {
                if (this.searchCriteria == null) {
                    return this.reatlas.states;
                }

                return _.filter(this.reatlas.states, (state) => {
                    return state.name?.toLowerCase().includes(this.searchCriteria.toLowerCase());
                });
            }
        },

        methods: {
            async toggleState(state) {
                if (this.creSiteIQ.selectedStates.includes(state)) { // remove state
                    this.creSiteIQ.selectedStates = _.without(this.creSiteIQ.selectedStates, state);
                    await this.$store.dispatch('removeZipBoundariesForState', state);
                    await this.$store.dispatch('refreshScores');
                } else { // add state
                    this.creSiteIQ.selectedStates.push(state);
                    await this.$store.dispatch('loadZipBoundariesForState', {
                        state: state,
                        callback: async () => {
                            await this.$store.dispatch('loadCRESiteIQZipCodeData');
                            // await this.$store.dispatch('filterCRESiteIQData');
                            await this.$store.dispatch('refreshScores');
                        }
                    });
                }
            },

            resetCRESiteIQMap() {
                this.$store.dispatch('clearCRESiteIQMap');
                this.creSiteIQ.selectedStates = [];
            }
        }
    }
</script>
